// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   Dashboard & Analytics Design System
   Shared visual language for every reporting / stats surface in the app.
   Import this once per page: 
   import "../../CommonElements/DashboardTheme/dashboard-theme.css"
   ========================================================================== */

:root {
  /* App brand color — sampled directly from the sidebar in production.
     This is NOT the same as Bootstrap's bg-primary/color="primary" in this
     app (that resolves to a purple/indigo, confirmed from the screenshot),
     so every banner/button/accent that should match the sidebar uses this
     token and the db-bg-brand / db-text-brand / db-btn-brand helpers below
     instead of Bootstrap's primary utilities. Update this one value if the
     real brand hex ever changes. */
  --db-brand: #006666;
  --db-brand-dark: #004d4d;
  --db-brand-soft: #e0eeee;

  /* Brand-neutral operations palette. Each metric family owns one accent. */
  --db-indigo: #4f46e5;      /* exhibitors / identity */
  --db-indigo-soft: #eef0fd;
  --db-emerald: #059669;     /* revenue / used / positive */
  --db-emerald-soft: #e7f6f0;
  --db-cyan: #0891b2;        /* verifications / badges */
  --db-cyan-soft: #e6f5f8;
  --db-amber: #d97706;       /* extras / pending */
  --db-amber-soft: #fdf1e2;
  --db-rose: #e11d48;        /* unused / risk */
  --db-rose-soft: #fce9ed;
  --db-slate: #334155;       /* vehicles / neutral ops */
  --db-slate-soft: #eaedf1;

  --db-bg: #f6f7fb;
  --db-surface: #ffffff;
  --db-border: #e6e8f0;
  --db-text: #1c2233;
  --db-text-muted: #6b7280;
  --db-text-faint: #98a2b3;

  --db-radius-lg: 16px;
  --db-radius-md: 12px;
  --db-radius-sm: 8px;

  --db-shadow-card: 0 1px 2px rgba(16, 24, 40, 0.04), 0 1px 3px rgba(16, 24, 40, 0.07);
  --db-shadow-card-hover: 0 8px 20px rgba(16, 24, 40, 0.09);
  --db-shadow-banner: 0 12px 32px rgba(0, 102, 102, 0.25);
}

/* ---------- Brand helpers (use these, not Bootstrap's bg-primary) ---------- */

.db-bg-brand { background-color: var(--db-brand) !important; }
.db-bg-brand-soft { background-color: var(--db-brand-soft) !important; }
.db-text-brand { color: var(--db-brand) !important; }
.db-border-brand { border-color: var(--db-brand) !important; }

.db-btn-brand {
  background-color: var(--db-brand);
  border-color: var(--db-brand);
  color: #fff;
}

.db-btn-brand:hover,
.db-btn-brand:focus,
.db-btn-brand:active {
  background-color: var(--db-brand-dark) !important;
  border-color: var(--db-brand-dark) !important;
  color: #fff !important;
}

/* ---------- Layout helpers ---------- */

.db-page {
  background: var(--db-bg);
}

.db-section {
  margin-bottom: 2rem;
}

.db-section-head {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  margin-bottom: 1rem;
}

.db-section-bar {
  width: 5px;
  height: 22px;
  border-radius: 4px;
  flex-shrink: 0;
}

.db-section-eyebrow {
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--db-text-faint);
  margin: 0 0 0.1rem;
  line-height: 1;
}

.db-section-title {
  font-size: 1.08rem;
  font-weight: 700;
  color: var(--db-text);
  margin: 0;
  line-height: 1.2;
}

/* ---------- Generic card shell ---------- */

.db-card {
  background: var(--db-surface);
  border: 1px solid var(--db-border);
  border-radius: var(--db-radius-lg);
  box-shadow: var(--db-shadow-card);
  transition: box-shadow 0.2s ease, transform 0.2s ease;
}

.db-card.db-card-hover:hover {
  box-shadow: var(--db-shadow-card-hover);
  transform: translateY(-3px);
}

/* ---------- KPI / stat cards ---------- */

.db-kpi-card {
  background: var(--db-surface);
  border: 1px solid var(--db-border);
  border-radius: var(--db-radius-lg);
  box-shadow: var(--db-shadow-card);
  padding: 1.1rem 1.2rem;
  height: 100%;
  transition: box-shadow 0.2s ease, transform 0.2s ease, border-color 0.2s ease;
  position: relative;
  overflow: hidden;
}

.db-kpi-card:hover {
  box-shadow: var(--db-shadow-card-hover);
  transform: translateY(-3px);
  border-color: transparent;
}

.db-kpi-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
}

.db-kpi-chip {
  width: 42px;
  height: 42px;
  min-width: 42px;
  border-radius: var(--db-radius-sm);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.05rem;
}

.db-kpi-eyebrow {
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--db-text-faint);
  margin-bottom: 0.3rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.db-kpi-value {
  font-size: 1.65rem;
  font-weight: 800;
  color: var(--db-text);
  line-height: 1.1;
  letter-spacing: -0.02em;
  word-break: break-word;
}

.db-kpi-sub {
  font-size: 0.76rem;
  color: var(--db-text-muted);
  margin-top: 0.35rem;
}

.db-trend-pill {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.7rem;
  font-weight: 700;
  padding: 0.18rem 0.5rem;
  border-radius: 999px;
  white-space: nowrap;
}

.db-trend-up {
  color: var(--db-emerald);
  background: var(--db-emerald-soft);
}

.db-trend-down {
  color: var(--db-rose);
  background: var(--db-rose-soft);
}

.db-trend-flat {
  color: var(--db-text-muted);
  background: var(--db-slate-soft);
}

/* Accent variants — background tint + icon color per metric family */
.db-accent-indigo { background: var(--db-indigo-soft); color: var(--db-indigo); }
.db-accent-emerald { background: var(--db-emerald-soft); color: var(--db-emerald); }
.db-accent-cyan { background: var(--db-cyan-soft); color: var(--db-cyan); }
.db-accent-amber { background: var(--db-amber-soft); color: var(--db-amber); }
.db-accent-rose { background: var(--db-rose-soft); color: var(--db-rose); }
.db-accent-slate { background: var(--db-slate-soft); color: var(--db-slate); }

.db-text-indigo { color: var(--db-indigo) !important; }
.db-text-emerald { color: var(--db-emerald) !important; }
.db-text-cyan { color: var(--db-cyan) !important; }
.db-text-amber { color: var(--db-amber) !important; }
.db-text-rose { color: var(--db-rose) !important; }
.db-text-slate { color: var(--db-slate) !important; }

/* ---------- Loading skeletons ---------- */

.db-skeleton {
  background: linear-gradient(90deg, #eef0f4 25%, #e3e6ee 37%, #eef0f4 63%);
  background-size: 400% 100%;
  animation: db-shimmer 1.4s ease infinite;
  border-radius: 6px;
}

@keyframes db-shimmer {
  0% { background-position: 100% 50%; }
  100% { background-position: 0 50%; }
}

/* ---------- Live activity banner ---------- */

.db-live-banner {
  position: relative;
  border-radius: var(--db-radius-lg);
  padding: 1.4rem 1.6rem;
  background-color: var(--db-brand);
  box-shadow: var(--db-shadow-banner);
  color: #fff;
  overflow: hidden;
}

.db-live-banner::before {
  content: "";
  position: absolute;
  inset: 0;
  background-image: radial-gradient(rgba(255, 255, 255, 0.10) 1px, transparent 1px);
  background-size: 18px 18px;
  opacity: 0.6;
  pointer-events: none;
}

.db-live-banner-head {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.1rem;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.db-live-banner-title {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  font-weight: 700;
  font-size: 1.05rem;
}

.db-live-pill {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  background: rgba(255, 255, 255, 0.16);
  border: 1px solid rgba(255, 255, 255, 0.22);
  padding: 0.3rem 0.75rem;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.03em;
}

.db-live-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #34d399;
  box-shadow: 0 0 0 0 rgba(52, 211, 153, 0.6);
  animation: db-pulse 1.8s infinite;
}

@keyframes db-pulse {
  0% { box-shadow: 0 0 0 0 rgba(52, 211, 153, 0.55); }
  70% { box-shadow: 0 0 0 8px rgba(52, 211, 153, 0); }
  100% { box-shadow: 0 0 0 0 rgba(52, 211, 153, 0); }
}

.db-live-group {
  position: relative;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: var(--db-radius-md);
  padding: 0.9rem 1rem 0.5rem;
  height: 100%;
}

.db-live-group-title {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-weight: 700;
  font-size: 0.82rem;
  margin-bottom: 0.7rem;
  color: rgba(255, 255, 255, 0.92);
}

.db-live-metric {
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.10);
  border-radius: var(--db-radius-sm);
  padding: 0.55rem 0.4rem;
  text-align: center;
  margin-bottom: 0.5rem;
  transition: background 0.15s ease;
}

.db-live-metric:hover {
  background: rgba(255, 255, 255, 0.13);
}

.db-live-value {
  font-size: 1.4rem;
  font-weight: 800;
  line-height: 1.1;
  word-break: break-word;
}

.db-live-label {
  font-size: 0.68rem;
  color: rgba(255, 255, 255, 0.78);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.28rem;
  margin-top: 0.25rem;
  text-align: center;
}

@media (max-width: 767.98px) {
  .db-live-value { font-size: 1.1rem; }
  .db-live-label { font-size: 0.62rem; }
}

/* ---------- Chart cards ---------- */

.db-chart-card {
  background: var(--db-surface);
  border: 1px solid var(--db-border);
  border-radius: var(--db-radius-lg);
  box-shadow: var(--db-shadow-card);
  padding: 1.25rem 1.35rem;
}

.db-chart-head {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1rem;
  margin-bottom: 1rem;
  flex-wrap: wrap;
}

.db-chart-title {
  font-size: 0.98rem;
  font-weight: 700;
  color: var(--db-text);
  margin: 0 0 0.15rem;
}

.db-chart-sub {
  font-size: 0.78rem;
  color: var(--db-text-muted);
  margin: 0;
}

.db-chart-total {
  text-align: right;
}

.db-chart-total-value {
  font-size: 1.15rem;
  font-weight: 800;
  line-height: 1.1;
}

.db-chart-total-label {
  font-size: 0.68rem;
  color: var(--db-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

/* ---------- Comparison (Yesterday vs Today) cards ---------- */

.db-compare-card {
  background: var(--db-surface);
  border: 1px solid var(--db-border);
  border-left: 4px solid var(--db-brand);
  border-radius: var(--db-radius-md);
  box-shadow: var(--db-shadow-card);
  padding: 1rem 1.1rem;
  height: 100%;
  transition: box-shadow 0.2s ease, transform 0.2s ease;
}

.db-compare-card:hover {
  box-shadow: var(--db-shadow-card-hover);
  transform: translateY(-2px);
}

.db-compare-label {
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--db-text-muted);
  text-align: center;
}

.db-compare-value {
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--db-text);
}

.db-compare-divider {
  color: var(--db-text-faint);
  font-weight: 300;
}

.db-compare-metric-name {
  text-align: center;
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--db-text-muted);
  margin-top: 0.5rem;
}

/* ---------- Operator branding (MTN / Airtel / other) ---------- */

.db-operator-badge {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.3rem;
  min-width: 0;
}

.db-operator-logo {
  height: 22px;
  max-width: 72px;
  width: auto;
  object-fit: contain;
}

.db-operator-name {
  font-size: 0.72rem;
  font-weight: 700;
  color: var(--db-text);
  white-space: nowrap;
}

.db-operator-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.3rem 0.7rem;
  border-radius: 999px;
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.02em;
  white-space: nowrap;
}

@media (max-width: 575.98px) {
  .db-operator-logo { height: 18px; max-width: 56px; }
  .db-operator-name { font-size: 0.66rem; }
  .db-operator-chip { font-size: 0.66rem; padding: 0.25rem 0.55rem; }
}

/* ---------- Data tables ---------- */

.db-table thead th {
  background: #fafafd;
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--db-text-muted);
  font-weight: 700;
  border-bottom: 1px solid var(--db-border);
}

.db-table td, .db-table th {
  vertical-align: middle;
}

/* ---------- Misc ---------- */

.db-divider {
  border: none;
  border-top: 1px solid var(--db-border);
  margin: 0.5rem 0 1.75rem;
}

.db-empty {
  text-align: center;
  color: var(--db-text-muted);
  padding: 1.75rem 1rem;
  font-size: 0.88rem;
}

@media (prefers-reduced-motion: reduce) {
  .db-live-dot, .db-skeleton { animation: none; }
  .db-kpi-card, .db-card, .db-compare-card { transition: none; }
}
`, "",{"version":3,"sources":["webpack://./src/Component/CommonElements/DashboardTheme/dashboard-theme.css"],"names":[],"mappings":"AAAA;;;;;+EAK+E;;AAE/E;EACE;;;;;;mCAMiC;EACjC,mBAAmB;EACnB,wBAAwB;EACxB,wBAAwB;;EAExB,0EAA0E;EAC1E,oBAAoB,OAAO,0BAA0B;EACrD,yBAAyB;EACzB,qBAAqB,MAAM,8BAA8B;EACzD,0BAA0B;EAC1B,kBAAkB,SAAS,2BAA2B;EACtD,uBAAuB;EACvB,mBAAmB,QAAQ,qBAAqB;EAChD,wBAAwB;EACxB,kBAAkB,SAAS,kBAAkB;EAC7C,uBAAuB;EACvB,mBAAmB,QAAQ,2BAA2B;EACtD,wBAAwB;;EAExB,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;;EAExB,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;;EAEnB,oFAAoF;EACpF,yDAAyD;EACzD,uDAAuD;AACzD;;AAEA,gFAAgF;;AAEhF,eAAe,4CAA4C,EAAE;AAC7D,oBAAoB,iDAAiD,EAAE;AACvE,iBAAiB,iCAAiC,EAAE;AACpD,mBAAmB,wCAAwC,EAAE;;AAE7D;EACE,iCAAiC;EACjC,6BAA6B;EAC7B,WAAW;AACb;;AAEA;;;EAGE,iDAAiD;EACjD,6CAA6C;EAC7C,sBAAsB;AACxB;;AAEA,yCAAyC;;AAEzC;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,2BAA2B;EAC3B,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,SAAS;EACT,gBAAgB;AAClB;;AAEA,6CAA6C;;AAE7C;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,kCAAkC;EAClC,iCAAiC;EACjC,qDAAqD;AACvD;;AAEA;EACE,uCAAuC;EACvC,2BAA2B;AAC7B;;AAEA,2CAA2C;;AAE3C;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,kCAAkC;EAClC,iCAAiC;EACjC,sBAAsB;EACtB,YAAY;EACZ,6EAA6E;EAC7E,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,2BAA2B;EAC3B,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA,qEAAqE;AACrE,oBAAoB,iCAAiC,EAAE,uBAAuB,EAAE;AAChF,qBAAqB,kCAAkC,EAAE,wBAAwB,EAAE;AACnF,kBAAkB,+BAA+B,EAAE,qBAAqB,EAAE;AAC1E,mBAAmB,gCAAgC,EAAE,sBAAsB,EAAE;AAC7E,kBAAkB,+BAA+B,EAAE,qBAAqB,EAAE;AAC1E,mBAAmB,gCAAgC,EAAE,sBAAsB,EAAE;;AAE7E,kBAAkB,kCAAkC,EAAE;AACtD,mBAAmB,mCAAmC,EAAE;AACxD,gBAAgB,gCAAgC,EAAE;AAClD,iBAAiB,iCAAiC,EAAE;AACpD,gBAAgB,gCAAgC,EAAE;AAClD,iBAAiB,iCAAiC,EAAE;;AAEpD,4CAA4C;;AAE5C;EACE,yEAAyE;EACzE,0BAA0B;EAC1B,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,KAAK,6BAA6B,EAAE;EACpC,OAAO,0BAA0B,EAAE;AACrC;;AAEA,+CAA+C;;AAE/C;EACE,kBAAkB;EAClB,kCAAkC;EAClC,sBAAsB;EACtB,iCAAiC;EACjC,mCAAmC;EACnC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,iFAAiF;EACjF,0BAA0B;EAC1B,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,qCAAqC;EACrC,2CAA2C;EAC3C,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;EAC3C,iCAAiC;AACnC;;AAEA;EACE,KAAK,4CAA4C,EAAE;EACnD,MAAM,2CAA2C,EAAE;EACnD,OAAO,yCAAyC,EAAE;AACpD;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,2CAA2C;EAC3C,kCAAkC;EAClC,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,kCAAkC;EAClC,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB,iBAAiB,EAAE;EACpC,iBAAiB,kBAAkB,EAAE;AACvC;;AAEA,sCAAsC;;AAEtC;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,kCAAkC;EAClC,iCAAiC;EACjC,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,gEAAgE;;AAEhE;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,sCAAsC;EACtC,kCAAkC;EAClC,iCAAiC;EACjC,oBAAoB;EACpB,YAAY;EACZ,qDAAqD;AACvD;;AAEA;EACE,uCAAuC;EACvC,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA,mEAAmE;;AAEnE;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB,YAAY,EAAE,eAAe,EAAE;EACnD,oBAAoB,kBAAkB,EAAE;EACxC,oBAAoB,kBAAkB,EAAE,wBAAwB,EAAE;AACpE;;AAEA,sCAAsC;;AAEtC;EACE,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;EAC3B,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,sBAAsB;AACxB;;AAEA,+BAA+B;;AAE/B;EACE,YAAY;EACZ,sCAAsC;EACtC,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B,eAAe,EAAE;EAC9C,2CAA2C,gBAAgB,EAAE;AAC/D","sourcesContent":["/* ==========================================================================\n   Dashboard & Analytics Design System\n   Shared visual language for every reporting / stats surface in the app.\n   Import this once per page: \n   import \"../../CommonElements/DashboardTheme/dashboard-theme.css\"\n   ========================================================================== */\n\n:root {\n  /* App brand color — sampled directly from the sidebar in production.\n     This is NOT the same as Bootstrap's bg-primary/color=\"primary\" in this\n     app (that resolves to a purple/indigo, confirmed from the screenshot),\n     so every banner/button/accent that should match the sidebar uses this\n     token and the db-bg-brand / db-text-brand / db-btn-brand helpers below\n     instead of Bootstrap's primary utilities. Update this one value if the\n     real brand hex ever changes. */\n  --db-brand: #006666;\n  --db-brand-dark: #004d4d;\n  --db-brand-soft: #e0eeee;\n\n  /* Brand-neutral operations palette. Each metric family owns one accent. */\n  --db-indigo: #4f46e5;      /* exhibitors / identity */\n  --db-indigo-soft: #eef0fd;\n  --db-emerald: #059669;     /* revenue / used / positive */\n  --db-emerald-soft: #e7f6f0;\n  --db-cyan: #0891b2;        /* verifications / badges */\n  --db-cyan-soft: #e6f5f8;\n  --db-amber: #d97706;       /* extras / pending */\n  --db-amber-soft: #fdf1e2;\n  --db-rose: #e11d48;        /* unused / risk */\n  --db-rose-soft: #fce9ed;\n  --db-slate: #334155;       /* vehicles / neutral ops */\n  --db-slate-soft: #eaedf1;\n\n  --db-bg: #f6f7fb;\n  --db-surface: #ffffff;\n  --db-border: #e6e8f0;\n  --db-text: #1c2233;\n  --db-text-muted: #6b7280;\n  --db-text-faint: #98a2b3;\n\n  --db-radius-lg: 16px;\n  --db-radius-md: 12px;\n  --db-radius-sm: 8px;\n\n  --db-shadow-card: 0 1px 2px rgba(16, 24, 40, 0.04), 0 1px 3px rgba(16, 24, 40, 0.07);\n  --db-shadow-card-hover: 0 8px 20px rgba(16, 24, 40, 0.09);\n  --db-shadow-banner: 0 12px 32px rgba(0, 102, 102, 0.25);\n}\n\n/* ---------- Brand helpers (use these, not Bootstrap's bg-primary) ---------- */\n\n.db-bg-brand { background-color: var(--db-brand) !important; }\n.db-bg-brand-soft { background-color: var(--db-brand-soft) !important; }\n.db-text-brand { color: var(--db-brand) !important; }\n.db-border-brand { border-color: var(--db-brand) !important; }\n\n.db-btn-brand {\n  background-color: var(--db-brand);\n  border-color: var(--db-brand);\n  color: #fff;\n}\n\n.db-btn-brand:hover,\n.db-btn-brand:focus,\n.db-btn-brand:active {\n  background-color: var(--db-brand-dark) !important;\n  border-color: var(--db-brand-dark) !important;\n  color: #fff !important;\n}\n\n/* ---------- Layout helpers ---------- */\n\n.db-page {\n  background: var(--db-bg);\n}\n\n.db-section {\n  margin-bottom: 2rem;\n}\n\n.db-section-head {\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n  margin-bottom: 1rem;\n}\n\n.db-section-bar {\n  width: 5px;\n  height: 22px;\n  border-radius: 4px;\n  flex-shrink: 0;\n}\n\n.db-section-eyebrow {\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--db-text-faint);\n  margin: 0 0 0.1rem;\n  line-height: 1;\n}\n\n.db-section-title {\n  font-size: 1.08rem;\n  font-weight: 700;\n  color: var(--db-text);\n  margin: 0;\n  line-height: 1.2;\n}\n\n/* ---------- Generic card shell ---------- */\n\n.db-card {\n  background: var(--db-surface);\n  border: 1px solid var(--db-border);\n  border-radius: var(--db-radius-lg);\n  box-shadow: var(--db-shadow-card);\n  transition: box-shadow 0.2s ease, transform 0.2s ease;\n}\n\n.db-card.db-card-hover:hover {\n  box-shadow: var(--db-shadow-card-hover);\n  transform: translateY(-3px);\n}\n\n/* ---------- KPI / stat cards ---------- */\n\n.db-kpi-card {\n  background: var(--db-surface);\n  border: 1px solid var(--db-border);\n  border-radius: var(--db-radius-lg);\n  box-shadow: var(--db-shadow-card);\n  padding: 1.1rem 1.2rem;\n  height: 100%;\n  transition: box-shadow 0.2s ease, transform 0.2s ease, border-color 0.2s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n.db-kpi-card:hover {\n  box-shadow: var(--db-shadow-card-hover);\n  transform: translateY(-3px);\n  border-color: transparent;\n}\n\n.db-kpi-top {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.75rem;\n}\n\n.db-kpi-chip {\n  width: 42px;\n  height: 42px;\n  min-width: 42px;\n  border-radius: var(--db-radius-sm);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.05rem;\n}\n\n.db-kpi-eyebrow {\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--db-text-faint);\n  margin-bottom: 0.3rem;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.db-kpi-value {\n  font-size: 1.65rem;\n  font-weight: 800;\n  color: var(--db-text);\n  line-height: 1.1;\n  letter-spacing: -0.02em;\n  word-break: break-word;\n}\n\n.db-kpi-sub {\n  font-size: 0.76rem;\n  color: var(--db-text-muted);\n  margin-top: 0.35rem;\n}\n\n.db-trend-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  font-size: 0.7rem;\n  font-weight: 700;\n  padding: 0.18rem 0.5rem;\n  border-radius: 999px;\n  white-space: nowrap;\n}\n\n.db-trend-up {\n  color: var(--db-emerald);\n  background: var(--db-emerald-soft);\n}\n\n.db-trend-down {\n  color: var(--db-rose);\n  background: var(--db-rose-soft);\n}\n\n.db-trend-flat {\n  color: var(--db-text-muted);\n  background: var(--db-slate-soft);\n}\n\n/* Accent variants — background tint + icon color per metric family */\n.db-accent-indigo { background: var(--db-indigo-soft); color: var(--db-indigo); }\n.db-accent-emerald { background: var(--db-emerald-soft); color: var(--db-emerald); }\n.db-accent-cyan { background: var(--db-cyan-soft); color: var(--db-cyan); }\n.db-accent-amber { background: var(--db-amber-soft); color: var(--db-amber); }\n.db-accent-rose { background: var(--db-rose-soft); color: var(--db-rose); }\n.db-accent-slate { background: var(--db-slate-soft); color: var(--db-slate); }\n\n.db-text-indigo { color: var(--db-indigo) !important; }\n.db-text-emerald { color: var(--db-emerald) !important; }\n.db-text-cyan { color: var(--db-cyan) !important; }\n.db-text-amber { color: var(--db-amber) !important; }\n.db-text-rose { color: var(--db-rose) !important; }\n.db-text-slate { color: var(--db-slate) !important; }\n\n/* ---------- Loading skeletons ---------- */\n\n.db-skeleton {\n  background: linear-gradient(90deg, #eef0f4 25%, #e3e6ee 37%, #eef0f4 63%);\n  background-size: 400% 100%;\n  animation: db-shimmer 1.4s ease infinite;\n  border-radius: 6px;\n}\n\n@keyframes db-shimmer {\n  0% { background-position: 100% 50%; }\n  100% { background-position: 0 50%; }\n}\n\n/* ---------- Live activity banner ---------- */\n\n.db-live-banner {\n  position: relative;\n  border-radius: var(--db-radius-lg);\n  padding: 1.4rem 1.6rem;\n  background-color: var(--db-brand);\n  box-shadow: var(--db-shadow-banner);\n  color: #fff;\n  overflow: hidden;\n}\n\n.db-live-banner::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background-image: radial-gradient(rgba(255, 255, 255, 0.10) 1px, transparent 1px);\n  background-size: 18px 18px;\n  opacity: 0.6;\n  pointer-events: none;\n}\n\n.db-live-banner-head {\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.1rem;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.db-live-banner-title {\n  display: flex;\n  align-items: center;\n  gap: 0.55rem;\n  font-weight: 700;\n  font-size: 1.05rem;\n}\n\n.db-live-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  background: rgba(255, 255, 255, 0.16);\n  border: 1px solid rgba(255, 255, 255, 0.22);\n  padding: 0.3rem 0.75rem;\n  border-radius: 999px;\n  font-size: 0.75rem;\n  font-weight: 700;\n  letter-spacing: 0.03em;\n}\n\n.db-live-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #34d399;\n  box-shadow: 0 0 0 0 rgba(52, 211, 153, 0.6);\n  animation: db-pulse 1.8s infinite;\n}\n\n@keyframes db-pulse {\n  0% { box-shadow: 0 0 0 0 rgba(52, 211, 153, 0.55); }\n  70% { box-shadow: 0 0 0 8px rgba(52, 211, 153, 0); }\n  100% { box-shadow: 0 0 0 0 rgba(52, 211, 153, 0); }\n}\n\n.db-live-group {\n  position: relative;\n  background: rgba(255, 255, 255, 0.07);\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  border-radius: var(--db-radius-md);\n  padding: 0.9rem 1rem 0.5rem;\n  height: 100%;\n}\n\n.db-live-group-title {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  font-weight: 700;\n  font-size: 0.82rem;\n  margin-bottom: 0.7rem;\n  color: rgba(255, 255, 255, 0.92);\n}\n\n.db-live-metric {\n  background: rgba(255, 255, 255, 0.06);\n  border: 1px solid rgba(255, 255, 255, 0.10);\n  border-radius: var(--db-radius-sm);\n  padding: 0.55rem 0.4rem;\n  text-align: center;\n  margin-bottom: 0.5rem;\n  transition: background 0.15s ease;\n}\n\n.db-live-metric:hover {\n  background: rgba(255, 255, 255, 0.13);\n}\n\n.db-live-value {\n  font-size: 1.4rem;\n  font-weight: 800;\n  line-height: 1.1;\n  word-break: break-word;\n}\n\n.db-live-label {\n  font-size: 0.68rem;\n  color: rgba(255, 255, 255, 0.78);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.28rem;\n  margin-top: 0.25rem;\n  text-align: center;\n}\n\n@media (max-width: 767.98px) {\n  .db-live-value { font-size: 1.1rem; }\n  .db-live-label { font-size: 0.62rem; }\n}\n\n/* ---------- Chart cards ---------- */\n\n.db-chart-card {\n  background: var(--db-surface);\n  border: 1px solid var(--db-border);\n  border-radius: var(--db-radius-lg);\n  box-shadow: var(--db-shadow-card);\n  padding: 1.25rem 1.35rem;\n}\n\n.db-chart-head {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 1rem;\n  margin-bottom: 1rem;\n  flex-wrap: wrap;\n}\n\n.db-chart-title {\n  font-size: 0.98rem;\n  font-weight: 700;\n  color: var(--db-text);\n  margin: 0 0 0.15rem;\n}\n\n.db-chart-sub {\n  font-size: 0.78rem;\n  color: var(--db-text-muted);\n  margin: 0;\n}\n\n.db-chart-total {\n  text-align: right;\n}\n\n.db-chart-total-value {\n  font-size: 1.15rem;\n  font-weight: 800;\n  line-height: 1.1;\n}\n\n.db-chart-total-label {\n  font-size: 0.68rem;\n  color: var(--db-text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n/* ---------- Comparison (Yesterday vs Today) cards ---------- */\n\n.db-compare-card {\n  background: var(--db-surface);\n  border: 1px solid var(--db-border);\n  border-left: 4px solid var(--db-brand);\n  border-radius: var(--db-radius-md);\n  box-shadow: var(--db-shadow-card);\n  padding: 1rem 1.1rem;\n  height: 100%;\n  transition: box-shadow 0.2s ease, transform 0.2s ease;\n}\n\n.db-compare-card:hover {\n  box-shadow: var(--db-shadow-card-hover);\n  transform: translateY(-2px);\n}\n\n.db-compare-label {\n  font-size: 0.72rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--db-text-muted);\n  text-align: center;\n}\n\n.db-compare-value {\n  font-size: 1.05rem;\n  font-weight: 700;\n  color: var(--db-text);\n}\n\n.db-compare-divider {\n  color: var(--db-text-faint);\n  font-weight: 300;\n}\n\n.db-compare-metric-name {\n  text-align: center;\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: var(--db-text-muted);\n  margin-top: 0.5rem;\n}\n\n/* ---------- Operator branding (MTN / Airtel / other) ---------- */\n\n.db-operator-badge {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.3rem;\n  min-width: 0;\n}\n\n.db-operator-logo {\n  height: 22px;\n  max-width: 72px;\n  width: auto;\n  object-fit: contain;\n}\n\n.db-operator-name {\n  font-size: 0.72rem;\n  font-weight: 700;\n  color: var(--db-text);\n  white-space: nowrap;\n}\n\n.db-operator-chip {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.3rem 0.7rem;\n  border-radius: 999px;\n  font-size: 0.72rem;\n  font-weight: 800;\n  letter-spacing: 0.02em;\n  white-space: nowrap;\n}\n\n@media (max-width: 575.98px) {\n  .db-operator-logo { height: 18px; max-width: 56px; }\n  .db-operator-name { font-size: 0.66rem; }\n  .db-operator-chip { font-size: 0.66rem; padding: 0.25rem 0.55rem; }\n}\n\n/* ---------- Data tables ---------- */\n\n.db-table thead th {\n  background: #fafafd;\n  font-size: 0.7rem;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--db-text-muted);\n  font-weight: 700;\n  border-bottom: 1px solid var(--db-border);\n}\n\n.db-table td, .db-table th {\n  vertical-align: middle;\n}\n\n/* ---------- Misc ---------- */\n\n.db-divider {\n  border: none;\n  border-top: 1px solid var(--db-border);\n  margin: 0.5rem 0 1.75rem;\n}\n\n.db-empty {\n  text-align: center;\n  color: var(--db-text-muted);\n  padding: 1.75rem 1rem;\n  font-size: 0.88rem;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .db-live-dot, .db-skeleton { animation: none; }\n  .db-kpi-card, .db-card, .db-compare-card { transition: none; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
